function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { DeviceType, XfinityVariant } from '@sky-uk-ott/client-lib-js-device';
/**
 * @public
 */ export function isSafariDesktop(deviceInfo, deviceType) {
    var _deviceInfo_browserName;
    return !!((_deviceInfo_browserName = deviceInfo.browserName) === null || _deviceInfo_browserName === void 0 ? void 0 : _deviceInfo_browserName.toLowerCase().includes('safari')) && deviceType === DeviceType.Browser;
}
export function isSafariMobile(deviceInfo, deviceType) {
    var _deviceInfo_browserName;
    return isSafariDesktop(deviceInfo, deviceType) && ((_deviceInfo_browserName = deviceInfo.browserName) === null || _deviceInfo_browserName === void 0 ? void 0 : _deviceInfo_browserName.toLowerCase()) === 'mobile safari';
}
export function isSafariMajorVersion(deviceInfo, deviceType, minimumMajorVersion) {
    var isSafari = isSafariDesktop(deviceInfo, deviceType);
    if (!isSafari) {
        return false;
    }
    try {
        var majorSafariVersion = parseInt(deviceInfo.browserVersion.split('.')[0], 10);
        return majorSafariVersion === minimumMajorVersion;
    } catch (e) {
        return false;
    }
}
export function isEdgeDesktop(deviceInfo, deviceType) {
    var _deviceInfo_browserName;
    return !!((_deviceInfo_browserName = deviceInfo.browserName) === null || _deviceInfo_browserName === void 0 ? void 0 : _deviceInfo_browserName.toLowerCase().includes('edge')) && deviceType === DeviceType.Browser;
}
export function isChromeDesktop(deviceInfo, deviceType) {
    var _deviceInfo_browserName;
    return !!((_deviceInfo_browserName = deviceInfo.browserName) === null || _deviceInfo_browserName === void 0 ? void 0 : _deviceInfo_browserName.toLowerCase().includes('chrome')) && deviceType === DeviceType.Browser;
}
export function isChromeOrChromium(deviceInfo) {
    var _deviceInfo_browserName;
    return !!((_deviceInfo_browserName = deviceInfo.browserName) === null || _deviceInfo_browserName === void 0 ? void 0 : _deviceInfo_browserName.toLowerCase().includes('chrome'));
}
export function isIOSDevice(deviceInfo, deviceType) {
    var _deviceInfo_operatingSystemName;
    return !!((_deviceInfo_operatingSystemName = deviceInfo.operatingSystemName) === null || _deviceInfo_operatingSystemName === void 0 ? void 0 : _deviceInfo_operatingSystemName.toLowerCase().includes('ios')) && deviceType === DeviceType.Browser;
}
export function isFirefoxDesktop(deviceInfo, deviceType) {
    var _deviceInfo_browserName;
    return !!((_deviceInfo_browserName = deviceInfo.browserName) === null || _deviceInfo_browserName === void 0 ? void 0 : _deviceInfo_browserName.toLowerCase().includes('firefox')) && deviceType === DeviceType.Browser;
}
export function isEdgeOnWindows(deviceInfo, deviceType) {
    return isEdgeDesktop(deviceInfo, deviceType) && isWindows(deviceInfo.operatingSystemName);
}
export function isMac(operatingSystemName) {
    return operatingSystemName.indexOf('Mac') > -1;
}
export function isWindows(operatingSystemName) {
    return operatingSystemName.indexOf('Windows') > -1;
}
export function getLgWebOsVersion(deviceInfo) {
    var _ref = _sliced_to_array((deviceInfo.browserVersion || '').match(/^WebOS ([0-9]+)/) || [], 2), webOsVersionMatch = _ref[1];
    return parseInt(webOsVersionMatch, 10);
}
export function getLgWebOsSubVersion(deviceInfo) {
    var match = deviceInfo.browserVersion.match(/^WebOS [0-9]+\.([0-9]+)/);
    if (match) {
        var minorVersion = parseInt(match[1], 10);
        return isNaN(minorVersion) ? 0 : minorVersion;
    }
    return 0;
}
export var isWebOsVeryLowPoweredDevice = function(deviceInfo) {
    if (!deviceInfo) {
        return false;
    }
    if (getLgWebOsVersion(deviceInfo) === 3 && getLgWebOsSubVersion(deviceInfo) <= 4) {
        return true;
    }
    return false;
};
export function getProsperoDeviceVersion(deviceInfo, deviceType) {
    if (deviceType === DeviceType.Prospero) {
        return parseInt(deviceInfo.deviceVersion, 10);
    }
    throw new Error('Check for prospero devices is only available for PS5 and PS4 (on Webmaf version equal or above 3)');
}
export function isPs4(deviceInfo, deviceType) {
    try {
        return getProsperoDeviceVersion(deviceInfo, deviceType) === 4;
    } catch (e) {
        return false;
    }
}
export function isIon() {
    return Object.prototype.hasOwnProperty.call(self, 'ion');
}
export function isYouviewHumax(deviceInfo) {
    var browserVersion = deviceInfo.browserVersion.split('/')[2];
    return parseFloat(browserVersion) < 600 ? true : false;
}
export function isX1(deviceType, deviceInfo) {
    return deviceType === DeviceType.Xfinity && deviceInfo.xfinityVariant === XfinityVariant.X1;
}
export function isXumosb(deviceType, deviceInfo) {
    return deviceType === DeviceType.Xfinity && deviceInfo.xfinityVariant === XfinityVariant.Xumosb;
}
export function isXClass(deviceType, deviceInfo) {
    return deviceType === DeviceType.Xfinity && deviceInfo.xfinityVariant === XfinityVariant.XClass;
}

//# sourceMappingURL=device-type.js.map